import { Schema } from 'yup';

type schemaItem = {
	title: string;
	type: string;
	ref?: string;
	content?: {
		helpText?: string;
		required?: boolean;
		map?: boolean;
		label?: string;
		validation?: {};
	};
};

const addCompanyInfo: schemaItem[] = [
	{
		title: 'company_name',
		type: 'string',
		content: {
			required: true,
		},
	},
	{
		title: 'company_number',
		content: {
			helpText:
				"Company number is optional, but can help us verify your company's identity.",
		},
		type: 'string',
	},

	//{
	// title: 'organizationNumber',
	// placeHolderValue: 'Company Number',
	// fieldState: 'companyNumber',
	// type: 'organisation',
	// furtherInformation: false,
	//},
	{
		title: 'industry_type',
		type: 'string',
	},
	{
		title: 'role',
		content: {
			helpText: 'What is your role in the company?',
		},
		type: 'string',
	},
	{
		title: 'interests',
		type: 'string',
	},
	{
		title: 'details',
		type: 'string',
		ref: 'textarea',
	},
	{
		title: 'country',
		type: 'country',
		content: {
			helpText:
				'Please select the country where your company is registered.',
		},
	},
];
export default addCompanyInfo;
